// Third Party Imports
import React from 'react';

// HA Artifactory modal
import Modal from '@homeaway/react-modal';
import {ButtonPrimary} from '@homeaway/react-buttons';

// Relative Imports
import './SaveAndFinishModal.less';
import alertSuccessIcon from '../../images/alertSuccess-icon.svg';


class SaveAndFinishModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            translations,
            isSaveModalOpen,
            handleSaveModalClose
        } = this.props;
        return (
            <div className="save-and-finish">
                <Modal
                    id="saveSuccessModal"
                    isOpen={isSaveModalOpen}
                    onClose={handleSaveModalClose}
                    footer={
                        <div className="ok-btn-holder">
                            <ButtonPrimary
                                label={translations['ipmob.save_modal.button_text']}
                                id="okBtn"
                                className="ok-btn"
                                onClick={handleSaveModalClose}
                            />
                        </div>
                    }
                >
                    <div className="alert-success-icon"><img src={alertSuccessIcon()}/></div>
                    <div className="save-modal-head">{translations['ipmob.save_modal.text_1']}</div>
                    <div className="save-modal-sub-head">{translations['ipmob.save_modal.text_2']}</div>
                </Modal>
            </div>
        );
    }
}

export default SaveAndFinishModal;
